module.exports = __webpack_public_path__ + "img/fr.c7191355.svg";